module.exports = __webpack_public_path__ + "media/KikiMC.6cf0d0d5.mp3";